// extracted by mini-css-extract-plugin
module.exports = {"container":"_d7","minus":"_d8","plus":"_d9","header":"_ea","question":"_eb","answer":"_ec"};